// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__1D1eh","content":"ManualTimeModal_content__30-FF"};